import { render } from "./DangCardCenterpiece.vue?vue&type=template&id=1fe122be&scoped=true"
import script from "./DangCardCenterpiece.vue?vue&type=script&lang=js"
export * from "./DangCardCenterpiece.vue?vue&type=script&lang=js"

import "./DangCardCenterpiece.vue?vue&type=style&index=0&id=1fe122be&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fe122be"]])

export default __exports__